module.exports = __webpack_public_path__ + "media/fonts/Oricons-dd58aa714c632a93d35d7b968a6641f0.ttf";